import axios from 'axios';
import { Message } from 'element-ui'; // 可选：用于错误提示
import { getSeqTypeDate } from '@/utils/date'

// 创建axios实例
// 将baseURL修改为代理路径
const service = axios.create({
    // 开发环境使用代理路径，生产环境使用真实API地址
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://app.starpeakstudios.cn:8030',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
        // 'Content-Type': 'application/x-www-form-urlencoded'

    }
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求前做些什么
        // 例如：添加token、设置请求头
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        // 处理请求错误
        console.error('请求错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 处理响应数据
        const res = response;

        // 根据业务状态码判断请求是否成功
        if (res.status !== 200) {
            Message({
                message: res.message || '请求失败',
                type: 'error',
                duration: 3000
            });

            // 例如：401表示未登录，跳转到登录页
            if (res.code === 401) {
                localStorage.removeItem('token');
                window.location.href = '/login';
            }

            return Promise.reject(new Error(res.message || '请求失败'));
        } else {
            return res.data; // 直接返回业务数据
        }
    },
    error => {
        // 处理响应错误
        console.error('响应错误:', error);

        Message({
            message: error.message || '网络错误',
            type: 'error',
            duration: 3000
        });
        return Promise.reject(error);
    }
);

// 获取房价
function GetRoomPriceList({ BeginDate, EndDate, RoomQty, OrderItemCode } = {}) {
    const data = {
        Seq: getSeqTypeDate(),
        ID: "WEB",
        Key: "qam3zfo21levvbv0w1cw",
        Func: "GetRoomPriceList",
        data: {
            BeginDate,
            EndDate,
            ProfileId: "",
            RoomQty,
            OrderItemCode,
            RateCode: "RR",
        },
    };

    return service.post('/pms', data)
}

// 获取房型
function GetRoomTypeList({ BeginDate, EndDate, RoomQty = 1 } = {}) {
    const data = {
        Seq: getSeqTypeDate(),
        ID: "WEB",
        Key: "qam3zfo21levvbv0w1cw",
        Func: "GetRoomTypeList",
        data: {
            "HodelCode": "",
            "OrderCategory": "RoomType",
            BeginDate,
            EndDate,
            "ProfileId": "",
            RoomQty
        },
    };

    return service.post('/pms', data)
}


function orderUpd({ OrderOperate = 'Add', OrderNo, OrderDetails, OrderType = 0, GuestType = '散客', PayMethodType, ContactName, ContactMobile ,TotalAmount,PaidAmount} = {}) {
    const data = {
        "Seq": getSeqTypeDate(),
        "ID": "WEB",
        "Key": "qam3zfo21levvbv0w1cw",
        "Func": "BookingOrderUpd",
        "data": {
            "token": localStorage.getItem('logingCode'),
            OrderOperate, //Add=新增訂單、Cancel=取消訂單、Prepay=檢查訂單、Update=修改訂單
            OrderNo, //單編號：新增訂單由我方生成 ** 修改訂單和取消訂單必須傳遞訂單編號
            "confirmationID": "", //網站生成的唯一標識
            "ConfirmationMode": "", //確認方式
            "WeixinID": "", //微信標識
            "ResortId": "", //酒店編號 ** 空白即可
            "ProfileId": "", //會員編號：如果是會員預訂時，則為會員唯一標識，其他情況不傳值
            "MbrCardNo": "", //會員卡號：如果是會員預訂時，則傳遞對應的會員卡號，其他情況不傳值
            GuestType, //客人類型：散客，會員 **下單和試單必傳
            "Source": 'webSite', //預訂來源：mobileSite=手機、app=手機網站、webSite=官網、weixin=微信 ** 下單和試單必
            PayMethodType, //付款方式：Alipay=支付寶、Payinhotel=到店支付、wxpay=財付通(含微信支付其他付款方式的話，訂單維護就不傳支付，需調用房賬掛賬介面 ** 下單和試單必傳
            "PaidRefId": "", //付款流水號 (用於對帳用)
            TotalAmount, //總金額 (此訂單所有明細及增值服務等的總金額
            PaidAmount, //付款金額(沒有線上支付的話則傳 0)  
            "ScorePaidAmount": "", //支付積分金額
            "CouponPaidAmount": "", //支付優惠券金額
            "CouponCodes": "", //支付優惠券編號(多張以逗號分隔)
            "ReturnMoneyPaidAmount": "", //支付返現金額
            "MbrCardPaidAmount": "", //支付會員卡餘額金額
            "ScorePaidRefId": "", //支付積分流水號(用於對賬用)
            "ReturnMoneyPaidRefId": "", //支付返現流水號(用於對賬用)
            "MbrCardPaidRefId": "", //支付卡餘額流水號(用於對賬用)
            ContactName, //連絡人姓名
            ContactMobile, //連絡人手機號
            "ContactTel": "", //連絡人電話
            "ContactEmail": "", //連絡人郵件
            "ConsumerRevertMsg": "", //取消原因：如果是取消訂單，則此處保存客人取消訂單的原因（取消必傳）** 其他操作則此欄位空
            OrderType, //訂單類型：0=客房訂單、1=餐飲訂單、2=溫泉門票訂單、3=直通車訂單、4:綜合訂單，前面幾項是當訂單的明細只包含一種產品時，則使用對應的訂單類型，如果包含多種產品時，則為綜合訂單。 ** 下單和試單必傳
            "MbrCardTypeCode": "", //會員卡類型
            "SalesCName": "", //業務員名稱
            "NCtrRoomQty": "", //不控制房量：傳 1 不控制房量，不傳或者傳其他則 pms 會校驗房量。
            "NCtrTime": "", //不控制時間：傳 1 的話入住和離店時間可以傳時分，不傳或者傳其他則取系統裡設置的抵店和離店時間
            OrderDetails
        }
    }

    console.log('data===========>', data);


    return service.post('/pms', data)
}


function getBookingOrder({ Mobile, GuestCname, OrderNo } = {}) {
    const data = {
        "Seq": getSeqTypeDate(),
        "ID": "WEB",
        "Key": "qam3zfo21levvbv0w1cw",
        "Func": "BookingOrderGet",
        "data": {
            "token": localStorage.getItem('logingCode'),
            "Hid ": "",
            OrderNo,
            "RegId": "",
            "ProfileId": "",
            "WeixinID": "",
            GuestCname,
            Mobile,
            "ConfirmationId ": "",
            "IsQueryLike": "1",
            "CertificateNo": "",
            "Status": "",
            "RoomNo": "",
            "CardNo": "",
            "MobileCode": "",
            "Gender": ""
        }
    }
    return service.post('/pms', data)

}

function getAllOrderData({ DateFrom, DateTo }={}) {
    const data = {
        "Seq": "20250526",
        "ID": "KS",
        "Key": "chk#az$ip7v6h!wrgm%2si",
        "Func": "GetAllOrderList",
        "data": {
            "token": localStorage.getItem('logingCode'),
            DateFrom:DateFrom||'',
            DateTo:DateTo||''
        }
    }

    return service.post('/KS', data)

}



function RoomStatus({ FloorID, RoomNo, ArrDate, DepDate, RoomTypeId, QType } = {}) {
    const data = {
        "Seq": getSeqTypeDate(),
        "ID": "WEB",
        "Key": "qam3zfo21levvbv0w1cw",
        "Func": "RoomStatusGet",
        "data": {
            "BuildingID": '',
            "FloorId": FloorID || "", //011671065F
            "RoomNo": RoomNo || '', //0501
            "ArrDate": ArrDate || '',
            "DepDate": DepDate || '',
            "RoomTypeId": RoomTypeId || '', //011671101
            "QType": QType || "2"
        }
    }
    // console.log(data.data);

    return service.post('/pms', data)
}


// 封装请求方法
export {
    GetRoomPriceList,
    GetRoomTypeList,
    orderUpd,
    getBookingOrder,
    RoomStatus,
    getAllOrderData
};